import { render, staticRenderFns } from "./car-buttons.vue?vue&type=template&id=243fa68b&scoped=true"
import script from "./car-buttons.vue?vue&type=script&lang=js"
export * from "./car-buttons.vue?vue&type=script&lang=js"
import style0 from "./car-buttons.vue?vue&type=style&index=0&id=243fa68b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243fa68b",
  null
  
)

export default component.exports